import { useCurrentPrimarySurvey } from '~/hooks/useCurrentPrimarySurvey'

export const useSurvey = () => useCurrentPrimarySurvey()
